module.exports = __webpack_public_path__ + "media/images/ic-lupa-busca-cinza-e9fbab8477506aae040fab1ed046e8ed.svg";